/**
 *
 * Asynchronously loads the component for PaymentForms
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import(
    /* webpackChunkName: "PaymentForms" */
    /* webpackPrefetch: true */
    './index'),
    { isPageLoad: true },);
